import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const RootContainer = styled.div`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  color: #999;
  text-align: center;
`;

const EndOfResultsMessage = () => {
  const { t } = useTranslation();

  return (
    <RootContainer>
      {t('search_end_of_result', 'End of Results')}
    </RootContainer>
  );
};

export default EndOfResultsMessage;
